import { InventaireForm } from "@features/stock/components/InventaireForm";
import { ROUTES } from "@features/stock/config/constants";
import { useUpdateInventaire } from "@features/stock/hooks/useInventaireMutations";
import { useInventaire } from "@features/stock/hooks/useInventaires";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/inventaires/$id/edit")({
  loader: requirePermission(PERMISSIONS.STOCK.INVENTAIRES.EDIT),
  component: EditInventaire,
});

function EditInventaire() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data: inventaire, isLoading } = useInventaire(Number(id));
  const updateMutation = useUpdateInventaire();

  const handleSuccess = () => {
    navigate({ to: ROUTES.STOCK.INVENTAIRES.LIST });
  };

  if (isLoading) {
    return <div className="skeleton h-32 w-full" />;
  }

  return (
    <div className="max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Modifier l'inventaire</h1>
      <div className="bg-base-100 rounded-lg shadow p-6">
        <InventaireForm mode="edit" initialData={inventaire} onSuccess={handleSuccess} />
      </div>
    </div>
  );
}
